import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "form-group mb-3"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Your password was successfully updated", -1)
const _hoisted_4 = {
  key: 2,
  class: "form-group mb-3"
}
const _hoisted_5 = {
  for: "password",
  class: "form-label"
}
const _hoisted_6 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_7 = {
  key: 3,
  class: "form-group mb-3"
}
const _hoisted_8 = {
  for: "passwordConfirmation",
  class: "form-label"
}
const _hoisted_9 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_10 = {
  key: 4,
  class: "form-group mt-4"
}
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTip = _resolveComponent("ToolTip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isFormInvalid)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "alert alert-danger",
          innerHTML: _ctx.validationMsg
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.passwordReset)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("button", {
            class: "btn back-btn btn-primary w-100",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToLogin && _ctx.goToLogin(...args)))
          }, " Login to My Account ")
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, [
            _createTextVNode("New Password"),
            _createVNode(_component_ToolTip, { tooltipText: "Enter a password for your account.<p>Password Requirements</p>\n                                                <ul>\n                                                    <li>Must be at least 10 characters but no longer than 128 characters</li>\n                                                    <li>Must not contain your username</li>\n                                                    <li>Must contain at least three of the following\n                                                        <ul>\n                                                            <li>Uppercase Letters</li>\n                                                            <li>Lowercase Letters</li>\n                                                            <li>Numbers</li>\n                                                            <li>Special Characters($&+,:;=?@#|.^*()%!-).</li>\n                                                        </ul>\n                                                    </li>\n                                                </ul>" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.password) = $event)),
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hideErrors('password'))),
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isSubmitDisabled = false)),
            id: "password",
            class: _normalizeClass(["form-control", _ctx.v$.user.password.$error ? 'is-invalid' : 'input-text'])
          }, null, 34), [
            [_vModelText, _ctx.user.password]
          ]),
          (_ctx.v$.user.password.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_ctx.v$.user.password.$invalid)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({ 'is-invalid': _ctx.v$.user.password.$error })
                    }, _toDisplayString(_ctx.v$.user.password.$silentErrors[0].$message), 3))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, [
            _createTextVNode("Confirm Password"),
            _createVNode(_component_ToolTip, { tooltipText: "Confirm the password you entered previously" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.passwordConfirmation) = $event)),
            onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hideErrors('passwordConfirmation'))),
            onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isSubmitDisabled = false)),
            id: "passwordConfirmation",
            class: _normalizeClass(["form-control", _ctx.v$.user.passwordConfirmation.$error ? 'is-invalid' : 'input-text'])
          }, null, 34), [
            [_vModelText, _ctx.user.passwordConfirmation]
          ]),
          (_ctx.v$.user.passwordConfirmation.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_ctx.v$.user.passwordConfirmation.$invalid)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({ 'is-invalid': _ctx.v$.user.passwordConfirmation.$error })
                    }, _toDisplayString(_ctx.v$.user.passwordConfirmation.$silentErrors[0].$message), 3))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("button", {
            name: "backBtn",
            class: "btn back-btn btn-primary w-20",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.backButtonHandler && _ctx.backButtonHandler(...args)))
          }, " BACK "),
          _createElementVNode("button", {
            disabled: _ctx.v$.user.$invalid || _ctx.isSubmitDisabled,
            class: _normalizeClass(["btn", [_ctx.buttonDesign()]]),
            id: "button-continue",
            type: "submit",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSubmit()))
          }, " CONTINUE ", 10, _hoisted_11)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}